const r = {
  colors: {
    primary: "var(--colors-primary)",
    black: "var(--colors-black)",
    white: "var(--colors-white)",
    grey100: "var(--colors-grey100)",
    grey200: "var(--colors-grey200)",
    grey300: "var(--colors-grey300)",
    grey400: "var(--colors-grey400)",
    grey500: "var(--colors-grey500)",
    grey600: "var(--colors-grey600)",
    success: "var(--colors-success)",
    success800: "var(--colors-success800)",
    success300: "var(--colors-success300)",
    error: "var(--colors-error)",
    error800: "var(--colors-error800)",
    error300: "var(--colors-error300)",
    warning: "var(--colors-warning)",
    info: "var(--colors-info)",
    cta: "var(--colors-cta)",
    cta800: "var(--colors-cta800)"
  }
};
export {
  r as t
};
